import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {Descriptions, notification} from 'antd';
import {List, WhiteSpace, ImagePicker, Toast} from 'antd-mobile';
import BottomPanel from "../../components/BottomPanel";
import OrderService from "../../apiServices/OrderService";
import cookie from "react-cookies";
import UserCarService from "../../apiServices/UserCarService";

class CompleteOrder extends Component {
    constructor(props){
        super(props);
        let orderItem = cookie.load('orderItem');
        let order_id = null;
        if(orderItem){ order_id = orderItem.order_id; }

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            hasError: false,
            hiddenBtn: false,
            order_id: order_id,
            full_name: '',
            email: '',
            phone_no: '',
            object_id: object_id,
            total_amount: 0,
            plate_number: '',
            car_brand: '',
            car_product: '',
            manufacturer_year: '',
            certificates: [],
            license: [],
            car_img: [],
        };
    }

    componentDidMount() {
        if(this.state.object_id){
            OrderService.findByObjectId(this.state.object_id).then(response=>{
                this.setState({
                    order_id: response.data.id,
                    full_name: response.data.full_name,
                    email: response.data.email,
                    phone_no: response.data.phone_no,
                    object_id: response.data.object_id,
                    total_amount: response.data.total_amount,

                    plate_number: response.data.plate_number,
                    car_brand: response.data.car_brand,
                    car_product: response.data.car_product,
                    manufacturer_year: response.data.car_year,
                    openCamera: 0,
                    image_data: null,
                    img_registration_certificate: null,
                });
            }).catch(function(error){
                console.log(error);
            });
        }else if(this.state.order_id){
            OrderService.detail(this.state.order_id).then(response => {
                this.setState({
                    full_name: response.data.full_name,
                    email: response.data.email,
                    phone_no: response.data.phone_no,
                    object_id: response.data.object_id,
                    total_amount: response.data.total_amount,

                    plate_number: response.data.plate_number,
                    car_brand: response.data.car_brand,
                    car_product: response.data.car_product,
                    manufacturer_year: response.data.car_year,
                    openCamera: 0,
                    image_data: null,
                    img_registration_certificate: null,
                });
            });
        }else{
            this.props.history.push('/');
        }
    }

    formSubmit = () => {

        if(this.state.certificates===[]){
            notification['error']({
                message: 'Bạn chưa chọn Ảnh đăng ký xe',
                description: '',
            });
        }else if (this.state.license === []){
            notification['error']({
                message: 'Bạn chưa chọn Ảnh giấy đăng kiểm xe',
                description: '',
            });
        }else if (this.state.car_img === []){
            notification['error']({
                message: 'Bạn chưa chọn ảnh Xe của bạn',
                description: '',
            });
        }else{
            Toast.loading('Loading...', 60);
            UserCarService.uploadImg({
                'id': this.state.object_id,
                'certificate_img': this.state.certificates[0],
                'license_img': this.state.license[0],
                'car_img': this.state.car_img,
            }).then(response => {
                Toast.hide();

                notification['success']({
                    message: 'Lưu hồ sơ thành công',
                    description: '',
                });

                this.setState({hiddenBtn: true});
                this.props.history.push('/');
            }).catch(error => {
                notification.error({
                    message: 'Không lưu được thông tin, vui lòng thử lại',
                    description: '',
                });
            });
        }
    };

    onChangeCertificate = (certificates, type, index) => {
        this.setState({
            certificates,
        });
    };

    onChangeLicense = (license, type, index) => {
        this.setState({
            license,
        });
    };

    onChangeCarImg = (car_img, type, index) => {
        this.setState({
            car_img,
        });
    };

    render() {
        return (
            <div className='App-block'>
                <DefaultLayout {...this.props} title="Hoàn thiện hồ sơ xe" showHome={true} classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <Descriptions title="" size="default" layout="horizontal" column={1}>
                            <Descriptions.Item label="Tên chủ xe">{this.state.full_name}</Descriptions.Item>
                            <Descriptions.Item label="Biển số xe">{this.state.plate_number}</Descriptions.Item>
                            <Descriptions.Item label="Hãng xe">{this.state.car_brand}</Descriptions.Item>
                            <Descriptions.Item label="Hiệu xe">{this.state.car_product}</Descriptions.Item>
                            <Descriptions.Item label="Năm sản xuất">{this.state.manufacturer_year}</Descriptions.Item>
                            <Descriptions.Item label="Tổng phí">{Number(this.state.total_amount).toLocaleString('en')+' đ'}</Descriptions.Item>
                        </Descriptions>
                        <WhiteSpace size='xl' />
                        <List>
                            <List.Item>
                                Ảnh đăng ký xe
                                <ImagePicker
                                    files={this.state.certificates}
                                    onChange={this.onChangeCertificate}
                                    accept="image/gif,image/jpeg,image/jpg,image/png"
                                    selectable={this.state.certificates.length < 1}
                                />
                            </List.Item>
                            <List.Item>
                                Ảnh giấy đăng kiểm xe
                                <ImagePicker
                                    files={this.state.license}
                                    onChange={this.onChangeLicense}
                                    accept="image/gif,image/jpeg,image/jpg,image/png"
                                    selectable={this.state.license.length < 1}
                                />
                            </List.Item>
                            <List.Item>
                                Ảnh xe của bạn
                                <ImagePicker
                                    files={this.state.car_img}
                                    onChange={this.onChangeCarImg}
                                    accept="image/gif,image/jpeg,image/jpg,image/png"
                                    selectable={this.state.car_img.length < 4}
                                />
                            </List.Item>
                        </List>
                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Lưu hồ sơ"} actionType='submit' actionContent={'order-auto-insurance-step3'}/>
            </div>
        )
    }
}

export default (withTranslation())(CompleteOrder);